import { useMutation } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export function useUpsertClaimDetail() {
  return useMutation(trpcOptions.app.upsertClaimDetail.mutationOptions())
}
